import { render, staticRenderFns } from "./EditInvoicesPage.vue?vue&type=template&id=4a5726fc&"
import script from "./EditInvoicesPage.vue?vue&type=script&lang=ts&"
export * from "./EditInvoicesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports